// extracted by mini-css-extract-plugin
export default {"arrow_icon":"S1_ManageLine_arrow_icon__+nTJa","title_main":"S1_ManageLine_title_main__83TE2","note":"S1_ManageLine_note__F6jQa"};